const initialState = () => ({
  company_products: [], // productos de la empresa
  paginate_company_products: {}, // paginacion de productos
  default_currencies: [], //divisas por defecto de la empresa
  fields_company_products: [], // campos personalizados de los productos
  paginate_fields_products: {}, // paginacion de los campos
})

export default initialState
